import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

class InputRadioLabel extends React.Component {
  static defaultProps = {
    isChecked: false
  }

  static propTypes = {
    isChecked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
  }

  handleClick () {
    this.props.onClick(!this.props.isChecked)
  }

  render () {
    const className = classNames({
      'inputRadio-field': true,
      'inputRadio-field_checked': !!this.props.isChecked
    })
    return (
      <button className={className} onClick={this.handleClick.bind(this)}>
        <div />
      </button>
    )
  }
}

export default InputRadioLabel
